import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { GetCurrentUserResidentsQuery } from "@graphql/api";
import DisplayPropertiesTableWithBackground from "@covertree/ui/content/DisplayPropertiesTableWithBackground";
import { mapSiteAddress } from "@utils";
import { formatPhoneNumber } from "@covertree/utils";

interface Props {
  data: GetCurrentUserResidentsQuery["getCurrentUserResidents"][number];
}

export default function YourDetails({ data }: Props) {
  return (
    <Box>
      <Typography variant="h4" mb={3}>
        Your Details
      </Typography>
      <Box mb={3}>
        <DisplayPropertiesTableWithBackground
          properties={[
            {
              label: "Resident Name",
              value: `${data.firstName} ${data.lastName}`,
            },
            {
              label: "Phone Number",
              value: formatPhoneNumber(data.phoneNumber),
            },
            {
              label: "Email",
              value: data.email ?? "-",
            },
            {
              label: "Community Name",
              value: data.community.name,
            },
            {
              label: "Site Address",
              value: mapSiteAddress(data.siteAddress),
            },
          ]}
          wideValues
        />
      </Box>
    </Box>
  );
}
